import { index, integer, pgTable, serial, text, timestamp } from 'drizzle-orm/pg-core'
import { user } from './user'

export const order = pgTable(
  'order',
  {
    id: serial('id').primaryKey(),
    created: timestamp().defaultNow().notNull(),
    updated: timestamp().defaultNow().notNull(),
    externalOrderId: text('external_order_id').notNull().unique(),
    ownerId: integer('owner_id')
      .references(() => user.id)
      .notNull(),
  },
  (table) => [index('order_owner_id_idx').on(table.ownerId)]
)

export type Order = typeof order.$inferSelect
export type InsertOrder = typeof order.$inferInsert
